import { FlowItem } from "./types";

export const FLOW_ITEMS: readonly FlowItem[] = [
  {
    label: "Bank balance",
    value: "£12,500",
    variant: "neutral",
  },
  {
    label: "VAT liability",
    value: "-£3,910",
    variant: "negative",
  },
  {
    label: "Protected reserve",
    value: "£1,263",
    variant: "positive",
  },
  {
    label: "Safe-to-Spend",
    value: "£3,247",
    variant: "highlight",
  },
] as const;
